/**
 * Deletes a cookie with the name specified, by setting it to expire in the past.
 * @param {The name of the cookie to expire} _name
 */
function DeleteBrowserCookie(_name) {
  document.cookie = `${_name}=; expires=Thu, 01 Jan 1970 00:00:01 GMT;`;
}

/**
 * Static method, returns an object of key/value pairs for all Browser
 * Cookies.
 */
function GetAllBrowserCookies() {
  const cookieArray = document.cookie.split(';');
  const cookieObject = {};

  for (let i = 0; i < cookieArray.length; i++) {
    let splitCookie = cookieArray[i].trim();
    splitCookie = splitCookie.split('=');
    cookieObject[splitCookie[0]] = splitCookie[1];
  }

  return cookieObject;
}

/**
 * Retrieves the value of a cookie by the name provided. If a cookie does not exist
 * with that name, undefined will be returned.
 * @param {The name of the cookie to retrieve the value of} _name
 */
function GetBrowserCookie(name) {
  const cookies = GetAllBrowserCookies();

  return cookies[name];
}

/**
 * Set a client-side cookie in the browser, that expires in a provided number of days.
 * @param {The name of the cookie to set} _name
 * @param {The value of the cookie to set} _value
 * @param {The number of days until the cookie expires} _days
 */
function SetBrowserCookie(_name, _value, _days) {
  const date = new Date();
  date.setTime(date.getTime() + (_days * 24 * 60 * 60 * 1000));

  const expires = `expires=${date.toUTCString()}`;
  document.cookie = `${_name}=${_value}; ${expires}`;
}

/**
 * Set a client-side cookie in the browser, that expires when the brower closes.
 * @param {The name of the cookie to set} _name
 * @param {The value of the cookie to set} _value
 * @param {The number of days until the cookie expires} _days
 */
function SetBrowserSessionCookie(_name, _value) {
  document.cookie = `${_name}=${_value}; `;
}

/*
    Named imports can be used like: import { DeleteBrowserCooke } from ...
    This allows using only a single, or subset of functions on import.
*/
export {
  DeleteBrowserCookie,
  GetBrowserCookie,
  GetAllBrowserCookies,
  SetBrowserCookie,
  SetBrowserSessionCookie,
};

/*
    Default imports can be used like: import BrowserCookies from ...
    This allows importing all functions and allows use of a shorthand notation for
    function names, treating this more like a static class.
*/
export default {
  Delete: DeleteBrowserCookie,
  Get: GetBrowserCookie,
  GetAll: GetAllBrowserCookies,
  Set: SetBrowserCookie,
  SetSession: SetBrowserSessionCookie,
};
